import BaseError from "./BaseError";

export default class ProxyError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 502,
      message,
      info: info || null,
      cause,
    });
    this.name = "ProxyError";
  }
}
